import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import ProductCard from "./product/Components/ProductCard";
import ProductDetails1 from "./ProductDetails1";
import { searchDesigners, normalizeMainScreenProducts } from "../api";
import Header from "../components/Header";
import { Circles } from "react-loader-spinner";
import Pagination from "./Pagination";

const SearchResultsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { query } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [totalItemCount, setTotalItemCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Number of items per page
  const [selectedFabric, setSelectedFabric] = useState(null);
  const [showFabricDetails, setShowFabricDetails] = useState(false);

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      try {
        const searchText = query.trim();
        const response = await searchDesigners(searchText);
        const items = normalizeMainScreenProducts(response);
        const categoryFilter = location.state?.categoryFilter;

        const filteredItems = items.filter(item => {
          if (String(item.recordType || item.record_type || '').toLowerCase() === 'fabric') {
            return true;
          }

          if (categoryFilter) {
            const prodCat = String(item.category || '').toLowerCase();
            return prodCat === categoryFilter.toLowerCase();
          }
          return true;
        });
        setProducts(filteredItems);
        setTotalItemCount(filteredItems.length);
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [query, navigate, location.state]);

  // Calculate the indices of the first and last items on the current page
  const lastItemIndex = currentPage * itemsPerPage;
  const firstItemIndex = lastItemIndex - itemsPerPage;

  // Create an array for just the current page's items
  const currentItems = products.slice(firstItemIndex, lastItemIndex);

  const handleProductClick = (product) => {
    setSelectedProduct(product);
    setShowDetails(true);
  };

  const handleFabricClick = (fabric) => {
    setSelectedFabric(fabric);
    setShowFabricDetails(true);
  };

  const closeFabricDialog = () => {
    setShowFabricDetails(false);
    setSelectedFabric(null);
  };

  const apparelItems = currentItems.filter(
    (item) => String(item.recordType || item.record_type || '').toLowerCase() !== 'fabric'
  );
  const fabricItems = currentItems.filter(
    (item) => String(item.recordType || item.record_type || '').toLowerCase() === 'fabric'
  );

  return (
    <div>
      <Header />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "2% 1% 0 1%",
          textAlign: "center",
        }}
      >
        <div
          className="back-icon_category"
          onClick={() => navigate(-1)}
          style={{ cursor: "pointer" }}
        >
          &lt; Back
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexGrow: 1,
          }}
        >
          <h1 style={{ margin: "0 1%" }}>
            Results for : {query} {location.state?.categoryFilter ? `in ${location.state.categoryFilter}` : ""}
          </h1>
          <h2
            style={{
              marginBottom: "1.9%",
              marginRight: "2.5%",
              color: "#007bff",
              fontWeight: 600,
            }}
          >
            Total Items: {totalItemCount}
          </h2>
        </div>
        <div style={{ width: 48 }} />
      </div>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "60vh",
          }}
        >
          <Circles
            height="80"
            width="80"
            color="#007bff"
            ariaLabel="loading"
          />
        </div>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              // height: "60vh",
              gap: "20px",
              flexWrap: "wrap",
              padding: "30px 2% 0 2%",
            }}
          >
            {currentItems.length === 0 ? (
              <h1 style={{ marginRight: "3%" }}>Sorry, No Products found !!</h1>
            ) : (
              <>
                {apparelItems.map((product, index) => (
                  <div
                    key={product.uniqueId || product.id || index}
                    onClick={() => handleProductClick(product)}
                  >
                    <ProductCard item={product} />
                  </div>
                ))}

                {fabricItems.map((fabric, index) => {
                  const primaryImage = fabric.imageUrls?.[0] || fabric.imageItems?.[0]?.url || "";

                  return (
                    <div
                      key={fabric.fabric_id || fabric.uniqueId || fabric.ID || `fabric-${index}`}
                      onClick={() => handleFabricClick(fabric)}
                      style={{
                        width: 210,
                        border: "1px solid #ddd",
                        borderRadius: 12,
                        background: "#f6f4fa",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.08)",
                        padding: 12,
                        cursor: "pointer",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 10,
                      }}
                    >
                      <h2 style={{ margin: 0, fontSize: 15, fontWeight: 500, color: "#222", textAlign: "center" }}>
                        {fabric.uniqueRecordId || fabric.ID || "Fabric"}
                      </h2>
                      <div
                        style={{
                          width: "100%",
                          height: 260,
                          borderRadius: 6,
                          overflow: "hidden",
                          background: "linear-gradient(180deg, #efefef 0%, #d9d9d9 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {primaryImage ? (
                          <img
                            src={primaryImage}
                            alt={fabric.fabricsup || "Fabric"}
                            style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                          />
                        ) : (
                          <div style={{ color: "#9c9c9c", fontWeight: 600, fontSize: 14 }}>Loading...</div>
                        )}
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          fontSize: 15,
                          fontWeight: 600,
                          color: "#1a1a1a",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {fabric.fabrictype || fabric.fabricsup || "No Fabric Type"}
                      </div>
                    </div>
                  );
                })}
              </>
            )}
          </div>
          <Dialog
            open={showFabricDetails}
            onClose={closeFabricDialog}
            PaperProps={{
              sx: {
                width: "100%",
                maxWidth: "79%",
                maxHeight: "100%",
                overflowX: "scroll",
                overflowY: "scroll",
                scrollBehavior: "auto",
              },
            }}
          >
            {selectedFabric ? (
              <>
                <DialogTitle sx={{ textAlign: "center" }}>
                  {selectedFabric.uniqueRecordId || selectedFabric.ID || "Fabric"}
                </DialogTitle>
                <DialogContent>
                  <ProductDetails1
                    productDetails1={selectedFabric}
                    handleEditProduct={() => {}}
                    handleDeleteProduct={() => {}}
                    onFabricUpdated={() => {}}
                  />
                </DialogContent>
              </>
            ) : null}
          </Dialog>
          {totalItemCount > itemsPerPage && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px", // Add some margin to separate pagination from products
              }}
            >
              <Pagination
                totalPosts={totalItemCount}
                postsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SearchResultsPage;
